var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnboardingCursor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.563 32.508L20.526 24.9M20.526 24.9L16.761 28.2375L17.6145 14.0325L25.455 25.908L20.526 24.9ZM18 3.375V6.75M26.751 6.999L24.3645 9.3855M30.375 15.75H27M11.6355 22.1145L9.2505 24.4995M9 15.75H5.625M11.6355 9.3855L9.2505 7.0005",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnboardingCursor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/onboarding-cursor.c8c2501e8ef50bb1aef8fc2e0b0ce859.svg";